// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Neon Metropolis Universe
 * 
 * Dimensional gateways connecting to other universes.
 */

export const warpGates = [
  {
    id: 'gate_neonmetropolis_to_milkyway',
    name: 'Origin Point Gateway',
    type: 'warpgate',
    distance: 15,
    coordinates: { x: 50, y: 55, z: 5 },
    destinationUniverse: 'milkyway',
    destinationGate: 'gate_milkyway_to_neonmetropolis',
    toSystem: 0, // Sol (Earth)
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#0088ff',
    hasRings: true,
    animated: true,
    discovered: true,
    description: 'Stable gateway to the Milky Way. Corporate-controlled dimensional portal. Return passage to origin universe. Zaibatsu security monitors all traffic.',
    scanDescription: 'ANALYSIS: Warp gate to universe "Milky Way" detected. Destination: Sol system (Earth). Corporate encryption: ACTIVE. Bidirectional travel confirmed. Gate travel does not consume fuel.'
  },
  {
    id: 'gate_neonmetropolis_to_improbability',
    name: 'Probability Glitch',
    type: 'warpgate',
    distance: 120,
    coordinates: { x: 35, y: 65, z: 8 },
    destinationUniverse: 'improbability',
    destinationGate: 'gate_improbability_to_neonmetropolis',
    toSystem: 300, // Improbability Sector start
    fuelRequired: 5,
    threat: 'IMPROBABLE',
    resources: 'INFINITE IMPROBABILITY',
    services: [],
    primaryColor: '#ffff00',
    secondaryColor: '#00ff00',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Quantum anomaly detected in cyberspace. AI constructs report impossible events. Corporate scientists unable to explain. Probability fields collapsing. Towel recommended.',
    scanDescription: 'ANALYSIS: Gateway to "Improbability Sector" detected. Cyberspace intersection with infinite improbability. Corporate AI constructs experiencing existential errors. Warning: Reality optional beyond this point. Don\'t Panic. Gate travel does not consume fuel.'
  },
  {
    id: 'gate_neonmetropolis_to_digiworld',
    name: 'Digital Nexus',
    type: 'warpgate',
    distance: 100,
    coordinates: { x: 40, y: 65, z: 10 },
    destinationUniverse: 'digiworld',
    destinationGate: 'gate_digiworld_to_neonmetropolis',
    toSystem: 900, // File Island
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'DIGITAL INTERFACE',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#00ff00',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Corporate firewall breach detected. Digital entities infiltrating cyberspace. AI constructs report evolution anomalies. Zaibatsu security compromised.',
    scanDescription: 'ANALYSIS: Gateway to "Digital World" detected. Destination: File Island system. Digital evolution patterns active. Corporate firewall: BREACHED. Data corruption risk: MODERATE. Gate travel does not consume fuel.'
  },
  {
    id: 'gate-neonmetropolis-marvel',
    name: 'Stark Tech Portal',
    type: 'warpgate',
    distance: 90,
    coordinates: { x: 55, y: 45, z: -8 },
    destinationUniverse: 'marvel',
    destinationGate: 'gate-marvel-neonmetropolis',
    toSystem: 2100, // Earth-616
    fuelRequired: 5,
    threat: 'LOW',
    resources: 'TECH PORTAL',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#ff0000',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Multiversal tech portal detected. Stark Industries signature. Connection to Earth-616.',
    scanDescription: 'ANALYSIS: Gateway to Marvel universe detected. Stark Tech compatible. Connection point: Earth-616. Gate travel does not consume fuel.'
  },
  {
    id: 'gate-neonmetropolis-dc',
    name: 'Wayne Tech Portal',
    type: 'warpgate',
    distance: 95,
    coordinates: { x: 35, y: 55, z: 6 },
    destinationUniverse: 'dc',
    destinationGate: 'gate-dc-neonmetropolis',
    toSystem: 1300, // Earth-Prime
    fuelRequired: 5,
    threat: 'LOW',
    resources: 'TECH PORTAL',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#0044cc',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Multiversal tech portal detected. Wayne Enterprises signature. Connection to Earth-Prime.',
    scanDescription: 'ANALYSIS: Gateway to DC universe detected. Wayne Tech compatible. Connection point: Earth-Prime. Gate travel does not consume fuel.'
  }
];

// Warp gate positions on the map
export const warpGatePositions = warpGates.reduce((acc, gate) => {
  acc[gate.id] = gate.coordinates;
  return acc;
}, {});